import {override} from "mobx";
import {ACTION_TYPES} from "../../../../../core/consts";
import {APP} from "../../../../../core/app/consts";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {GameCenterTabModel} from "./game-center.tab-model";

export class GameCenterMatchTabModel extends GameCenterTabModel {
  @override get isVisible(): Boolean {
    return true;
  }

  get eventName(): String {
    return ACTION_TYPES.matchDetailsClick;
  }

  get eventParams(): Object {
    const eventParams = {
      gameId: this.entity.id,
      competitionId: this.entity.competition.id,
      status: this.entity.statusGroup,
      source: APP.ANALYTICS.SOURCES.gameCenterTabs,
      currentLinkModelName: this.currentLinkModel?.name,
      sportTypeId: this.entity.sport.id
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.match;
  }

  get elementId(): String {
    return 'navigation-tabs_game-center_match';
  }
}
